import React, { Component } from 'react'

class WordResults extends Component {
    render() {
        return (
            <div className='container'>
                <b>RESULTS</b>
                {this.props.word_holder.map((results,index) => (
                        <div key={index}>
                            {index + 1} : {results.term}
                        </div>
                        ))}
            </div>
        )
    }
}

export default WordResults



// WEBPACK FOOTER //
// ./src/components/layout/WordResults.js